<template>
  <div class="overflow-y-auto p-4">
    <h1 class="mb-2">
      {{ t("headings.document") }}
    </h1>
    <div class="grid gap-4">
      <div
        class="card p-4"
        :class="{
          'flex h-1/2 items-center justify-center': waiting,
        }"
      >
        <p v-if="waiting" class="text-xl font-bold">
          {{ t("labels.loading") }}
        </p>
        <div v-else>
          <h3 class="mb-3">{{ document.name }}</h3>
          <read-only
            v-if="document.content"
            :content="JSON.parse(document.content)"
          />
          <hr class="my-3 border-gray-300" />
          <div class="flex justify-end">
            <div
              v-if="
                document.signatories &&
                document.signatories[0].status === 'signed'
              "
              class="flex items-center gap-2"
            >
              <CheckCircleIcon class="h-6 w-6 text-green-600" />
              <p class="text-lg font-semibold">
                {{ t("labels.signed") }}
              </p>
            </div>
            <form-button
              v-else
              :command="() => sign()"
              :disabled="waiting"
              id="sign-button"
              label="sign"
              textVariant="light"
              type="submit"
              variant="indigo"
            />
          </div>
        </div>
      </div>
      <div v-if="!waiting" class="card p-4">
        <h3 class="mb-3">{{ t("headings.attachments") }}</h3>
        <div
          v-if="!document.attachments || !document.attachments.length"
          class="py-8 text-center"
        >
          {{ t("labels.no_files") }}
        </div>
        <div
          v-else
          class="grid grid-cols-2 gap-4 py-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6"
        >
          <div
            v-for="(file, fileIndex) in document.attachments"
            :key="fileIndex"
            class="cursor-pointer rounded-md border border-slate-300 p-4 hover:border-indigo-500"
            @click="openFile(file.path)"
          >
            <DocumentIcon class="text-indigo-500" />
            <div class="truncate font-bold">{{ file.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  DocumentArrowUpIcon,
  DocumentIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import ReadOnly from "../components/editor/ReadOnly.vue";
import FormButton from "../components/form/FormButton.vue";
export default {
  components: {
    ArrowDownTrayIcon,
    CheckCircleIcon,
    DocumentArrowUpIcon,
    DocumentIcon,
    FormButton,
    ReadOnly,
    XMarkIcon,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();

    const attachment = computed(() => store.state.file.file);
    const document = computed(() => store.state.document.document);

    const waiting = computed(() => {
      if (store.state.document.waiting) return true;
      return false;
    });

    const openFile = (path) => {
      store.dispatch("file/getFile", path);
    };

    onMounted(() => {
      if (!document.value.id || document.value.id != route.params.documentId) {
        store.dispatch("document/getSignableDocument", {
          documentId: route.params.documentId,
          slug: route.params.slug,
        });
      }
    });

    watch(
      () => attachment.value,
      (val) => {
        if (val) {
          window.open(val, "_blank");
        }
      }
    );

    return {
      document,
      openFile,
      router,
      sign: () =>
        store.dispatch("document/signDocument", {
          documentId: document.value.id,
          slug: route.params.slug,
        }),
      t,
      waiting,
    };
  },
};
</script>
